import { useGetBillingInfo } from '@repo/api-codegen/v2';
import { Navigate, useSearchParams } from 'react-router';
import { OnboardingSubscriptionController } from '../../features/OnboardingSubscription';
import { AuthLayoutBase } from './AuthLayouts/AuthLayoutBase';

export function AuthStepPayment() {
	const [searchParams] = useSearchParams();
	const { data: billingInfo } = useGetBillingInfo({});
	const subscriptionReactivate = !['active', 'trialing'].includes(
		billingInfo?.subscription_status ?? ''
	);

	if (searchParams.get('redirect_status') === 'succeeded') {
		return <Navigate to="/onboarding/confirm" />;
	}

	return (
		<AuthLayoutBase>
			<OnboardingSubscriptionController
				title={
					subscriptionReactivate
						? 'Reactivate your subscription'
						: 'Start your 7 day free trial'
				}
				subtitle="Start automating data questions with a powerful Al assistant built for data"
				priceText={
					subscriptionReactivate
						? 'Comprehensive AI-enabled data analysis'
						: '$20 per user/month after trial'
				}
				cancelText={
					subscriptionReactivate
						? 'Cancel your subscription at anytime'
						: 'Cancel your trial at anytime'
				}
				features={[
					'$20 in AI credits per user/month',
					'Access to Data warehouse, database, and transformation integrations',
					'Q&A management',
					'Slack integration',
					'AI personas and filters',
					'Light data catalog',
					'Data glossary',
					'Data documentation',
					'SSO',
				]}
				showCompanyCarousel={true}
				width="800px"
			/>
		</AuthLayoutBase>
	);
}
